<template>
  <BaseTag
    v-bind="$attrs"
    v-on="$listeners"
    :disabled="disabled"
    :freeze="freeze"
    :selected="state"
    :styleConfig="styleConfig"
    @click="toggleState"
  >
    <template v-slot:state>
      <slot name="state" />
    </template>
    <template v-slot:text>
      <slot name="text">
        <slot />
      </slot>
    </template>
    <template v-slot:controller>
      <slot name="controller" />
    </template>
  </BaseTag>
</template>

<script>
  import BaseTag from '@base/v2/base-tag'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'TagTogglePrimary',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'change',
    },
    components: {
      BaseTag,
    },
    props: {
      vmodelValue: {
        type: [Boolean, Object],
        required: true,
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      freeze: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data: function () {
      return {
        state: this.vmodelValue,
        styleConfig: {
          container: {
            cursor: {
              '': 'pointer',
              disabled: 'default',
            },
          },
          controller: {},
          root: {},
          state: {},
          text: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.sm,
            fontWeight: FontStyle.weight.lg,
            userSelect: 'none',
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.styleConfig.container,
        {
          backgroundColor: {
            '': this.color.dark6(),
            disabled: this.color.dark3(),
            selected: this.color.select1(),
          },
          borderRadius: Layout.space.sm,
          height: Layout.space.lg,
          padding: `${Layout.space.xs} ${Layout.space.sm}`,
        },
      );
      Object.assign(
        this.styleConfig.text,
        {
          color: {
            '': this.color.dark3(),
            disabled: this.color.dark5(),
            selected: this.color.light1(),
          },
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
    methods: {
      toggleState: function (event) {
        if (this.disabled || this.freeze) {
          return;
        }
        this.state = !this.state;
        this.$emit('change', this.state);
      },
    },
    watch: {
      vmodelValue: function (newVal, oldVal) {
        this.state = newVal;
      },
    },
  };
</script>
